import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import { twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

/**
 * Better Auth browser client. The oauth-provider plugin transparently carries
 * a signed OIDC authorization request through sign-in, so users arriving from
 * a connected app are sent straight back after authenticating.
 */
export const authClient = createAuthClient({
  basePath: "/api/auth",
  plugins: [twoFactorClient(), oauthProviderClient()],
});

/** Follow a server-issued redirect (OIDC continuation) if present. */
export function followAuthRedirect(data: unknown): boolean {
  const d = data as { redirect?: boolean; url?: string } | null;
  if (d?.url && (d.redirect ?? true)) {
    const target = new URL(d.url, window.location.origin);
    if (target.protocol === "https:" || target.origin === window.location.origin) {
      window.location.assign(target.toString());
      return true;
    }
  }
  return false;
}
